module.exports = __webpack_public_path__ + "img/language.ea556d87.png";